<template>
<div>
  <span class="sr-only" aria-live="polite">{{ alertText }}</span>

  <div id="activity_instructions" class="text-white p-4">To move each pattern, either drag and drop the box to a new position, or tab to a box and use the up or down arrow keys to change position.</div>

  <div class="vrank flex flex-wrap items-center">
    <div class="sort-wrapper flex flex-wrap w-3/12 md:w-2/12 mb-3 text-center pr-2">
      <span class="flex-wrap w-full font-bold text-sm text-right pr-2">More Stress</span>

      <ul class="w-1/5 flex flex-col text-center">
        <li v-for="(choice, index) in itemsarray" class="flex mb-2 h-12 justify-center items-center font-bold text-xl">
            {{ index + 1 }}
        </li>
      </ul>

      <draggable :list="itemsarray"
        animation="600"
        tag="ul"
        class="w-4/5 flex flex-col"
        role="listbox"
        :move="onMove"
      >
        <li v-for="(choice, index) in itemsarray"
          :id="choice.column"
          class="columnfill h-12 flex mb-2 overflow-hidden justify-center items-center rounded shadow w-full cursor-move text-sm"
          :key="choice.id"
          :ref="'sidebar_' + index"
          role="option"
          draggable="true"
          tabindex="1"
          @keyup.arrow-up="arrowUp('sidebar', choice, index)"
          @keyup.arrow-down="arrowDown('sidebar', choice, index)"
        >
            <h2 class="label relative text-base py-0">
              {{ choice.attributes['title'].text }}
            </h2>
        </li>
      </draggable>

      <span class="flex-wrap w-full font-bold text-sm text-right pr-2 -mt-2">Less Stress</span>
        <div class="mt-3 inline-block m-auto" v-if="demo !== ('1')">
          <button id="submitResults" tabindex="1" @click="putResults" type="submit" class="submitResults px-5 py-2">Next<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        </div>

        <div class="mt-3 inline-block m-auto"  v-else>
          <button @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl icon-flipped">refresh</i></button>
        </div>
    </div>
    
    <div class="vrank-wrapper w-9/12 md:w-10/12 py-3 flex flex-row">
      <div class="hidden md:flex flex-col w-20">
        <div class="flex-1" style="background: linear-gradient(to top, rgba(255, 148, 0, 0) 0%, rgba(255, 148, 0, 0.3) 100%);">
          <p class="mt-1">MORE STRESS</p>
        </div>
        <div class="flex flex-1 items-end" style="background: linear-gradient(to bottom, rgba(75, 0, 130, 0) 0%, rgba(75, 0, 130, 0.3) 100%)">
          <p>LESS STRESS</p>
        </div>
      </div>

      <draggable :list="itemsarray"
        animation="600"
        tag="ul"
        class="vrank-responsive"
        handle=".handle"
        role="listbox"
        :move="onMove"
      >
        <li v-for="(choice, index) in itemsarray"
          :id="choice.column"
          class="vrank-item"
          :key="choice.id"
          :ref="'main_' + index"
          role="option"
          draggable="true"
          tabindex="1"
          @keyup.arrow-up="arrowUp('main', choice, index)"
          @keyup.arrow-down="arrowDown('main', choice, index)"
        >
          <div class="handle"></div>
          <!-- <div class="flex items-center absolute right-0 top-0 w-6 justify-center bg-gray-200 cursor-move">{{ index + 1 }}</div> -->
          <div class="flex-grow align-middle">
            <div class="attributes flex flex-col">
                    <span class="label relative">{{ choice.attributes['title'].text }}
                      <button
                        v-if="choice.attributes['showmore']"
                        class="showmore"
                        @click="showModal(index)"
                      > 
                        <i aria-hidden="true" class="material-icons">help</i>
                      </button>
                    </span>
                    <p class="description">
                      <img v-if="choice.attributes.image" :src="choice.attributes.image.text" :alt="choice.attributes.title.text" class="image float-right"/>
                      <span v-html="choice.attributes['description'].text">
                      {{ choice.attributes['description'].text }}</span>
                      <card-modal :ref="'modal_' + index" v-if="choice.attributes['showmore']">
                        {{ choice.attributes['showmore'].text }}
                      </card-modal>
                    </p>
            </div>
          </div>
        </li>
      </draggable>
    </div>
    
  </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

export default {
  display: "Simple",
  order: 1,
  components: {
    draggable,
  },
  props: {
      array: '',
      route:'',
      demo:'',
  },
  data() {
    return {
      itemsarray: this.getItemsWithColumns(),
      alertText: '',
    }
  },
  methods: {
    showModal(index) {
      let modal_id = "modal_" + index;
      this.$refs[modal_id][0].show(index);
    },
    restartActivity() {
      $( ".submitResults").addClass( "loading" );
      location.reload();
    },
    getItemsWithColumns() {
      return this.array.map((item, index) => {
        item.column = 'column_' + (index + 1);
        return item;
      });
    },
    putResults: function (event) {
      $( "#submitResults").addClass( "loading" );
      axios.put(this.route, {
        results: this.itemsarray.map(dataSet => dataSet.id)
      }).then(function (response) {
          console.log(response);
        }).then(function (event) {
          location.reload();
        })
    },
    arrowUp(section, choice, index) {
      if (index > 0) {
        let newIndex = index - 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    arrowDown(section, choice, index) {
      if (index < this.itemsarray.length - 1) {
        let newIndex = index + 1;
        this.moveItem(index, newIndex);
        this.updateAlertText(choice.attributes.title.text, newIndex);
        this.focusItem(section, newIndex);
      }
    },
    updateAlertText(title, newIndex) {
      this.alertText = title + ', ranked ' + (newIndex + 1) + ' of ' + (this.itemsarray.length);
    },
    moveItem(fromIndex, toIndex) {
      let element = this.itemsarray[fromIndex];
      this.itemsarray.splice(fromIndex, 1);
      this.itemsarray.splice(toIndex, 0, element);
    },
    focusItem(prefix, index) {
      this.$nextTick(() => {
        let el = this.$refs[prefix + '_' + index];

        if (el && el[0]) {
          el[0].focus();
        }
      })
    },
    onMove(move) {
      if (move.draggedContext) {
        let title = move.draggedContext.element.attributes.title.text;
        let newIndex = move.draggedContext.futureIndex;
        this.updateAlertText(title, newIndex)
      }
    },
  },
};
</script>
